import { render } from "./DevelopersView.vue?vue&type=template&id=55f537ef"
import script from "./DevelopersView.vue?vue&type=script&lang=js"
export * from "./DevelopersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__